<div class="row">
  <div class="col-12">
    <h2>
      <i class="fas fa-plug"></i>
      <span>Integrations Statistics</span>
    </h2>
  </div>
</div>
<ng-container *ngIf="isLoading$ | async; else content"
  ><app-loading-spinner></app-loading-spinner
></ng-container>

<ng-template #content>
  <div class="totals row">
    <div class="col-4">
      <div class="card">
        <div class="card-body">
          <span>Total Integrations:</span>
          <h3>{{ (integrations$ | async).length }}</h3>
        </div>
      </div>
    </div>
    <div class="col-4">
      <div class="card">
        <div class="card-body">
          <span>Total Accounts:</span>
          <h3>{{ totalAccounts$ | async }}</h3>
        </div>
      </div>
    </div>
    <div class="col-4">
      <div class="card">
        <div class="card-body">
          <span>Total Installs:</span>
          <h3>{{ totalSections$ | async }}</h3>
        </div>
      </div>
    </div>
  </div>

  <div class="row" [style.marginTop.px]="10">
    <div class="col-12">
      <div class="table-responsive">
        <table class="table bg-white table-hover">
          <thead>
            <tr>
              <th scope="col">Integration</th>
              <th scope="col">Author</th>
              <th scope="col">Accounts</th>
              <th scope="col">Installations</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let integration of integrations$ | async">
              <td>
                <a routerLink="/integrations/{{ integration.id }}">
                  {{ integration.id }}
                </a>
              </td>
              <td>{{ integration.author }}</td>
              <td>{{ integration.installations.accounts }}</td>
              <td>{{ integration.installations.sections }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</ng-template>
